const ProjectDetailContent = ({ project }) => {
  if (!project) return null;

  const highlightedFeatures = project.features?.slice(0, 4) || [];
  const hasExecutionNotes =
    Array.isArray(project.challenges) &&
    project.challenges.length > 0 &&
    Array.isArray(project.solutions) &&
    project.solutions.length > 0;

  return (
    <div className="pd">
      <div className="pd__header">
        <div className="pd__hero">
          <div className="pd__visual">
            <div className="pd__img-wrapper">
              <img src={project.mainimage} alt={project.title} />
            </div>
          </div>
          <div className="pd__main-info">
            <h1 className="pd__title">{project.title}</h1>
            <p className="pd__short-desc">{project.description}</p>

            <div className="pd__meta-grid">
              <div className="pd__meta-item pd__meta-item--stack">
                <span className="pd__meta-label">CORE STACK</span>
                <div className="pd__tech-pills">
                  {project.technologies.slice(0, 4).map((tech, i) => (
                    <span key={i} className="pd__tech-pill">
                      {tech.name}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="pd__actions">
              <a
                href={project.url}
                target="_blank"
                rel="noreferrer"
                className="pd__btn pd__btn-primary"
              >
                View Live Product <i className="uil uil-arrow-up-right"></i>
              </a>
              {project.github && (
                <a
                  href={project.github}
                  target="_blank"
                  rel="noreferrer"
                  className="pd__btn pd__btn-outline"
                >
                  Technical Source <i className="uil uil-github"></i>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="pd__content">
        <div className="pd__container">
          <div className="pd__case-study">
            <section className="pd__section">
              <h2 className="pd__section-title">Business Context</h2>
              <div className="pd__text-block">
                <p className="pd__full-desc">{project.fullDescription}</p>
              </div>
            </section>

            <div className="pd__grid">
              <section className="pd__section">
                <h2 className="pd__section-title">What I Delivered</h2>
                <div className="pd__features">
                  {highlightedFeatures.map((feature, i) => (
                    <div className="pd__feature-card" key={i}>
                      <i className="uil uil-check-circle pd__feature-icon"></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </section>
            </div>

            {hasExecutionNotes && (
              <section className="pd__section">
                <h2 className="pd__section-title">Execution Notes</h2>
                <div className="pd__challange-grid">
                  <div className="pd__challage-box">
                    <h3 className="pd__sub-title">Challenge</h3>
                    <ul className="pd__list">
                      {project.challenges.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="pd__solution-box">
                    <h3 className="pd__sub-title">Solution</h3>
                    <ul className="pd__list">
                      {project.solutions.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </section>
            )}

            {project.videoUrl && (
              <section className="pd__section">
                <h2 className="pd__section-title">Live Demo</h2>
                <div className="pd__video-wrapper">
                  <iframe
                    src={project.videoUrl}
                    title="Project Demo"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              </section>
            )}

            <section className="pd__section pd__cta-section">
              <h2 className="pd__section-title">Need Similar Results?</h2>
              <p className="pd__full-desc pd__cta-text">
                If you&apos;re a founder, hiring manager, or business owner, I
                can take your idea from concept to production with clear
                ownership.
              </p>
              <div className="pd__actions">
                <a
                  href="https://cal.com/ahadali/lets-engineer-your-bespoke-product?overlayCalendar=true&layout=month_view"
                  target="_blank"
                  rel="noreferrer"
                  className="pd__btn pd__btn-primary"
                >
                  Book a 1-1 Meeting <i className="uil uil-calendar-alt"></i>
                </a>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailContent;
